import data from './data'

export default {
  data,
  resourcePath: '/v1/patient/settings/policy'
}



// WEBPACK FOOTER //
// ./src/app/patient/privacy-policy/index/resources/index.js